import * as Actions from '../services/actions';

function onActivate(store, toState, fromState) {
	const search = { ...toState.params };	
	const settings = store.getState().settings;
	if (Object.keys(settings).length > 0) {
		return store.dispatch(Actions.searchEntries(search));
	}
}

export default [
	{
		name: 'list',
		path: '/',
		onActivate
	},
];